import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';

import Input from '../../../components/Input';
import Toggle from '../../../components/Toggle';

export default function Form() {
  return (
    <SpaceBetween size="m">
      <Input name="name" label="Anzeigename" stretch />
      <Input name="url" label="Url" stretch />
      <Box>
        <SpaceBetween size="s">
          <Toggle
            defaultValue={true}
            label="Aktive"
            description="Soll dieser Eintrag auf der Webseite sichtbar sein."
            name="is_active"
          />
        </SpaceBetween>
      </Box>
    </SpaceBetween>
  );
}
